var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarMLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "98.215mm",
    height: "98.514mm",
    viewBox: "0 0 98.215 98.514",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-63.334 -97.458)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.44607,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.97043 .24137 -.2559 .9667 0 0)",
    x: 108.62,
    y: 107.52,
    width: 2.3649,
    height: 49.093,
    ry: 0,
    strokeWidth: 0.23715
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.4434 -.89632 .6813 .73201 0 0)",
    x: -34.188,
    y: 136.33,
    width: 1.8684,
    height: 35.485,
    ry: 0,
    strokeWidth: 0.17921
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.83662 .54778 -.55639 .83092 0 0)",
    x: 168.75,
    y: 24.858,
    width: 2.3621,
    height: 50.158,
    ry: 0,
    strokeWidth: 0.23956
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.95095 -.30934 .27027 .96278 0 0)",
    x: 90.577,
    y: 145.5,
    width: 3.7454,
    height: 83.256,
    ry: 0,
    strokeWidth: 0.38865
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.7656 -.64332 .80465 .59376 0 0)",
    x: -17.439,
    y: 151.8,
    width: 1.8251,
    height: 22.142,
    ry: 0,
    strokeWidth: 0.13992
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.064569 .99791 -.95781 .28739 0 0)",
    x: 148.63,
    y: -156.54,
    width: 2.3313,
    height: 28.998,
    ry: 0,
    strokeWidth: 0.18096
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "red",
    cx: 127.82,
    cy: 113.94,
    r: 16.484,
    fillOpacity: 0.54719,
    strokeWidth: 0.16044
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 127.82,
    cy: 114.03,
    r: 9.7325,
    strokeWidth: 0.094727
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.95,
    cy: 154.34,
    r: 2.4677,
    strokeWidth: 0.024018
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.097,
    cy: 131.01,
    r: 2.621,
    strokeWidth: 0.025511
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.225,
    cy: 178.04,
    r: 2.8912,
    strokeWidth: 0.02814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.09,
    cy: 192.31,
    r: 3.6595,
    strokeWidth: 0.035618
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.03,
    cy: 100.35,
    r: 1.9244,
    strokeWidth: 0.01873
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.47,
    cy: 104.91,
    r: 3.0811,
    strokeWidth: 0.029989
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarMLogo);
export default __webpack_public_path__ + "static/media/StarMLogo.ac338af59d7f6f7302121a1778f5627c.svg";
export { ForwardRef as ReactComponent };